import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { push } from "redux-first-history";
import toast from "react-hot-toast";

import * as http from "../../utils/requests";
import { setCpf as setCpfAction } from "../../redux/actions/session";

import Menu from "../../components/menuDesktop/MenuDesktop";
import MobileMenu from "../../components/menuMobile/MenuMobile";

import "./CpfRegistration.scss";

const formatCpf = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9)
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};

const CpfRegistration = () => {
  const token = useSelector((state) => state.session.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "/";

  const [cpf, setCpf] = useState("");
  const [cpfError, setCpfError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!token) return null;

  const handleClose = () => navigate("/");

  const handleCpfChange = (e) => {
    setCpf(formatCpf(e.target.value));
    setCpfError("");
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const cleanCpf = cpf.replace(/\D/g, "");
    if (cleanCpf.length !== 11) {
      return setCpfError("CPF deve possuir 11 dígitos.");
    }

    setIsSubmitting(true);
    try {
      const response = await http.patch("users", { cpf: cleanCpf });
      if (response.status === 200) {
        dispatch(setCpfAction(cleanCpf));
        toast.success("CPF cadastrado com sucesso!");
        dispatch(push(`/${redirect}`));
      }
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.detail);
      } else {
        toast.error("Erro ao cadastrar CPF.");
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <Menu />

      <div
        className="tx-modal-overlay"
        role="dialog"
        aria-modal="true"
        onClick={(e) => {
          if (e.target === e.currentTarget) handleClose();
        }}
      >
        <form className="tx-modal" onSubmit={handleSubmit} noValidate>
          <header className="tx-modal__header">
            <h2 className="tx-modal__title">Cadastre seu CPF/Pix</h2>
            <button
              type="button"
              className="tx-modal__close"
              onClick={handleClose}
              aria-label="Fechar"
            >
              <i className="fa-solid fa-xmark" />
            </button>
          </header>

          <p className="tx-modal__description">
            Para realizar depósitos e saques, precisamos do seu CPF
            (será sua chave PIX).
          </p>

          <label className="tx-field">
            <span className="tx-field__label">CPF</span>
            <div className="tx-field__input-wrap">
              <i className="fa-regular fa-id-card tx-field__prefix-icon" />
              <input
                type="text"
                className="tx-field__input tx-field__input--with-prefix"
                placeholder="000.000.000-00"
                value={cpf}
                onChange={handleCpfChange}
                maxLength={14}
                inputMode="numeric"
              />
            </div>
            {cpfError && (
              <span className="tx-field__error">{cpfError}</span>
            )}
          </label>

          <button
            type="submit"
            className="tx-modal__submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Salvando..." : "Salvar CPF"}
          </button>
        </form>
      </div>

      <MobileMenu />
    </>
  );
};

export default CpfRegistration;
